import React from "react";
import image1 from "../../../assets/images/1.png";
import image2 from "../../../assets/images/2.png";
import image3 from "../../../assets/images/logo.jpg";
import { t } from "i18next";

const AboutUs = () => (
    <main className="about_content">
        <section className="content">
            <h1 className="m_0">{t('aboutUs')}</h1>
        </section>
        <section id="mission" className="section content">
            <h2>{t('aboutUsText1')}</h2>
            <img src={image1} alt="Field view" className="section-image" />
            <p>
                {t('aboutUsText2')}
            </p>
            <hr className="divider"></hr>
            <section id="project" className="section">
                <h2>{t('aboutUsText3')}</h2>
                <img src={image2} alt="Partnership" className="section-image" />
                <p>
                    {t('aboutUsText4')}
                </p>
            </section>
        </section>
        <section id="project" className="section-logo content">
            <h2>{t('aboutUsText5')}</h2>
            <img src={image3} alt="Partnership" className="section-image-logo" />
        </section>
    </main>
);

export default AboutUs;